import React, { useMemo } from "react";
import { AutoFields, EditView, useGet } from "@builtbypixel/nucleus";
import useSWR from "swr";
import setup from "./setup";
import CustomFile from "../../components/FileUpload";

const EditForm = () => {
  const { data: categories } = useSWR("/resource-categories", useGet);

  const fields = useMemo(
    () => [
      {
        group: "",
        fields: [
          {
            name: "name",
            component: "text",
            placeholder: "Name",
            label: "Name",
            isRequired: true,
            rules: { required: true },
          },
          {
            name: "description",
            component: "text",
            placeholder: "Description",
            label: "Description",
            isRequired: false,
          },
          {
            name: "parent",
            component: "select",
            options: categories?.data,
            labelKey: "name",
            valueKey: "id",
            placeholder: "Parent Category",
            label: "Parent Category",
          },
          {
            name: "content",
            component: "repeater",

            placeholder: "Content",
            label: "Assets",
            fieldArray: [
              {
                name: "title",
                component: "text",
                placeholder: "Asset Title",
                label: "Asset Title",
                isRequired: true,
                rules: { required: true },
              },
              {
                name: "file",
                isMultiple: true,
                max: 999,
                component: CustomFile,
                placeholder: "File",
                label: "File",
                isRequired: true,
                rules: { required: true },
              },
            ],
          },
        ],
      },
    ],
    [categories]
  );
  return (
    <EditView setup={setup}>
      <AutoFields fields={fields} />
    </EditView>
  );
};

export default EditForm;
